import React, { useState, useRef, useEffect } from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Sort } from '../../../../../static/icons/sort';
import { Check } from '../../../../../static/icons/check';
import colors from '../../../../../tailwind.colors';
import { sortOptions } from '../../../../constants/systemSortOptions';

const SortDropdown = ({ selectedSort, onSelectSort, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const onSelect = (id) => {
    onSelectSort(id);
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} className="flex relative max-sm:self-start">
      <button
        type="button"
        onClick={toggleDropdown}
        className="flex w-fit items-center h-10 global-hover gap-1"
      >
        <Sort />
        <Typography fontVariant="h8">{t('catFilter.sort')}</Typography>
      </button>
      <ul
        className={`flex flex-col absolute right-0 border border-customGray-300 bg-white cursor-pointer shadow-xl mt-10 rounded-md transform transition duration-300 ease-out origin-top-right min-w-[240px] p-2 gap-1 ${
          isOpen ? 'scale-100' : 'scale-0'
        }`}
      >
        {sortOptions.map((menuItem) => (
          <li key={menuItem.id}>
            <button
              type="button"
              className="flex justify-between items-center py-2 global-hover w-full"
              onClick={() => onSelect(menuItem.id)}
            >
              <Typography textAlign="left" className="!text-md">
                {t(menuItem.label)}
              </Typography>
              {selectedSort === menuItem.id && (
                <Check color={colors.customGray[900]} />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SortDropdown;
